/* ============================================================
   COOKIE CHOICES — the deli's own, in place of Shopify's stock box.

   Harry, 16 Oct 2026: "make sure everything cookie banner-wise is really
   beautiful, state-of-the-art ... perfectly on-brand ... so that hopefully
   people don't say no and they just accept it."

   WHAT IT IS. One small card, in the site's type and colours, that answers
   Shopify's own consent switch (window.Shopify.customerPrivacy). Shopify still
   decides WHO is asked (shouldShowBanner: the regions set in Admin > Customer
   privacy) and still keeps the answer (its _tracking_consent cookie), so the
   pixels for Google, Meta and Klaviyo obey this card exactly as they obeyed
   the stock box. Nothing about who is tracked changed; only how they are asked.

   HOW IT EARNS A YES, AND WHERE THE LINE IS.
   - It is warm, short and specific about what the cookies do; it arrives a
     beat after the page, at the edge, and never blocks the hamper finder.
   - "Accept all" is the filled button. "Essentials only" sits beside it at the
     same size: the ICO expects saying no to be as easy as saying yes on the
     first layer, and a banner that hides the no is the one regulators write to.
   - Nothing is switched on before somebody presses. FERAL's banner treats
     silence as yes; that is not lawful under PECR for a UK shop, so it is not
     copied here.
   - "Cookie settings" is added to the footer's legal row on every page, so a
     choice can be changed as easily as it was made.

   MEASURED, not guessed: each decision is one beacon to the deli's own door
   (the basket's /signal, see site/_cart.js): cookie-shown, cookie-accept,
   cookie-essentials, cookie-choose, cookie-save. `deli watch` counts them, so
   the accept rate can be read and any change to this card judged by it.

   If anything here throws, the class that hides Shopify's box is taken off
   again, so a visitor is never left unasked.
   ============================================================ */
(function () {
  'use strict';
  var doc = document, html = doc.documentElement, W = window;
  if (W.__admConsent) return;
  W.__admConsent = true;

  /* ---------- the look: the site's own tokens, with fallbacks ---------- */
  var CSS = ''
  + 'html.adm-consent #shopify-pc__banner,html.adm-consent #shopify-pc__prefs{display:none!important}'
  + '.ck{--ck-navy:var(--navy,#2B3A5A);--ck-night:var(--night,#1A2439);--ck-bright:var(--bright,#FCF9F0);--ck-ivory:var(--ivory,#F7F1E3);'
  +   '--ck-brass:var(--brass,#A98E4A);--ck-brass-ink:var(--brass-ink,#7A6120);--ck-hair:var(--hair,rgba(43,58,90,.16));'
  +   '--ck-ease:var(--ease,cubic-bezier(.22,.61,.21,1));'
  +   'position:fixed;z-index:2147483647;right:24px;bottom:24px;width:min(408px,calc(100vw - 48px));box-sizing:border-box;'
  +   'background:var(--ck-bright);color:var(--ck-navy);border:1px solid var(--ck-hair);'
  +   'box-shadow:0 1px 0 rgba(255,255,255,.7) inset,0 28px 64px -24px rgba(26,36,57,.42),0 6px 18px -8px rgba(26,36,57,.18);'
  +   'font:400 15px/1.5 var(--sans,"Inter",-apple-system,"Helvetica Neue",sans-serif);-webkit-font-smoothing:antialiased;'
  +   'opacity:0;transform:translateY(18px);transition:opacity 500ms var(--ck-ease),transform 500ms var(--ck-ease);}'
  + '.ck.is-in{opacity:1;transform:none}'
  + '.ck.is-out{opacity:0;transform:translateY(12px);transition-duration:380ms}'
  + '.ck *{box-sizing:border-box}'
  + '.ck-in{padding:24px 24px 20px}'
  + '.ck-top{display:flex;gap:16px;align-items:flex-start}'
  + '.ck-mark{flex:0 0 auto;width:44px;height:44px;color:var(--ck-brass);margin-top:2px}'
  + '.ck-mark svg{display:block;width:100%;height:100%}'
  + '.ck-mark .ck-crumb{transform-origin:50% 50%;transition:transform 700ms var(--ck-ease),opacity 700ms var(--ck-ease)}'
  + '.ck-eye{margin:0 0 4px;font:600 11px/1.2 var(--sans,"Inter",sans-serif);letter-spacing:.16em;text-transform:uppercase;color:var(--ck-brass-ink)}'
  + '.ck-title{margin:0;font:400 23px/1.15 var(--serif,"Fraunces",Georgia,serif);letter-spacing:-.012em;color:var(--ck-night);'
  +   'font-variation-settings:"opsz" 48}'
  + '.ck-title em{font-style:italic}'
  + '.ck-body{margin:10px 0 0;color:rgba(43,58,90,.84);font-size:14.5px;line-height:1.55;text-wrap:pretty}'
  + '.ck-body a,.ck-choose{color:var(--ck-navy);text-decoration:underline;text-decoration-color:rgba(169,142,74,.7);'
  +   'text-decoration-thickness:1px;text-underline-offset:3px;transition:text-decoration-color 220ms var(--ck-ease)}'
  + '.ck-body a:hover,.ck-choose:hover{text-decoration-color:var(--ck-navy)}'
  + '.ck-acts{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:20px}'
  + '.ck-btn{appearance:none;display:inline-flex;align-items:center;justify-content:center;gap:8px;min-height:48px;padding:0 16px;'
  +   'border:1px solid var(--ck-navy);border-radius:0;cursor:pointer;font:600 14.5px/1 var(--sans,"Inter",sans-serif);letter-spacing:.005em;'
  +   'transition:background 220ms var(--ck-ease),color 220ms var(--ck-ease),border-color 220ms var(--ck-ease),transform 120ms var(--ck-ease)}'
  + '.ck-btn:active{transform:translateY(1px)}'
  + '.ck-yes{background:var(--ck-navy);color:var(--ck-bright)}'
  + '.ck-yes:hover{background:var(--ck-night);border-color:var(--ck-night)}'
  + '.ck-no{background:transparent;color:var(--ck-navy)}'
  + '.ck-no:hover{background:rgba(43,58,90,.06)}'
  + '.ck-btn:focus-visible,.ck-choose:focus-visible,.ck-body a:focus-visible,.ck-sw input:focus-visible+span{outline:2px solid var(--ck-navy);outline-offset:3px}'
  + '.ck-foot{display:flex;justify-content:space-between;align-items:center;margin-top:14px;font-size:13.5px}'
  + '.ck-choose{appearance:none;background:none;border:0;padding:4px 0;cursor:pointer;font:500 13.5px/1.2 var(--sans,"Inter",sans-serif)}'
  + '.ck-note{color:rgba(43,58,90,.7)}'
  /* the choices, opened in place */
  + '.ck-more{display:grid;grid-template-rows:0fr;transition:grid-template-rows 420ms var(--ck-ease)}'
  + '.ck.is-open .ck-more{grid-template-rows:1fr}'
  + '.ck-more>div{overflow:hidden;min-height:0}'
  + '.ck-list{list-style:none;margin:18px 0 0;padding:0;border-top:1px solid var(--ck-hair)}'
  + '.ck-row{display:flex;gap:16px;align-items:flex-start;justify-content:space-between;padding:14px 0;border-bottom:1px solid var(--ck-hair)}'
  + '.ck-row b{display:block;font:500 15px/1.3 var(--sans,"Inter",sans-serif);color:var(--ck-night)}'
  + '.ck-row small{display:block;margin-top:3px;font-size:13px;line-height:1.45;color:rgba(43,58,90,.76)}'
  + '.ck-sw{position:relative;flex:0 0 auto;width:44px;height:26px;margin-top:2px;cursor:pointer}'
  + '.ck-sw input{position:absolute;inset:0;width:100%;height:100%;margin:0;opacity:0;cursor:inherit}'
  + '.ck-sw span{position:absolute;inset:0;border-radius:999px;background:rgba(43,58,90,.16);transition:background 220ms var(--ck-ease)}'
  + '.ck-sw span:after{content:"";position:absolute;top:3px;left:3px;width:20px;height:20px;border-radius:50%;background:#fff;'
  +   'box-shadow:0 1px 3px rgba(26,36,57,.3);transition:transform 220ms var(--ck-ease)}'
  + '.ck-sw input:checked+span{background:var(--ck-navy)}'
  + '.ck-sw input:checked+span:after{transform:translateX(18px)}'
  + '.ck-sw.is-locked{cursor:default}.ck-sw.is-locked input:checked+span{background:rgba(43,58,90,.42)}'
  + '.ck.is-open .ck-foot{display:none}'
  /* thank-you, then away */
  + '.ck-done{display:none;align-items:center;gap:12px;padding:20px 24px;font-size:14.5px;color:var(--ck-navy)}'
  + '.ck-done svg{flex:0 0 auto;width:22px;height:22px;color:var(--ck-brass-ink)}'
  + '.ck.is-done .ck-in{display:none}.ck.is-done .ck-done{display:flex}'
  /* a phone: a sheet along the bottom, short enough to leave the page readable */
  + '@media (max-width:760px){'
  +   '.ck{left:0;right:0;bottom:0;width:auto;border-width:1px 0 0;max-height:88vh;overflow:auto;'
  +     'box-shadow:0 -18px 48px -24px rgba(26,36,57,.45);transform:translateY(100%)}'
  +   '.ck.is-out{transform:translateY(100%)}'
  +   '.ck-in{padding:18px 20px calc(16px + env(safe-area-inset-bottom,0px))}'
  +   '.ck-done{padding:18px 20px calc(18px + env(safe-area-inset-bottom,0px))}'
  /* smaller on a phone (Harry, 20 Oct 2026): it covered the bottom third of the builder's first screen,
     where the ready-made hampers now sit. Same words and buttons, less room around them. */
  +   '.ck-in{padding-top:12px;padding-bottom:calc(10px + env(safe-area-inset-bottom,0px))}'
  +   '.ck-top{gap:10px;align-items:center}'
  +   '.ck-mark{width:24px;height:24px;margin-top:0}'
  +   '.ck-eye,.ck-note{display:none}'
  +   '.ck-title{font-size:17px}'
  +   '.ck-body{font-size:13px;line-height:1.42;margin-top:5px}'
  +   '.ck-acts{margin-top:10px;gap:8px}'
  +   '.ck-btn{min-height:44px}'
  +   '.ck-foot{margin-top:2px;justify-content:center}'
  + '}'
  + '@media (prefers-reduced-motion:reduce){.ck,.ck-more,.ck-mark .ck-crumb{transition:none}}'
  + 'html.ck-up .intercom-lightweight-app-launcher,html.ck-up .intercom-launcher-frame,html.ck-up #intercom-container .intercom-launcher{opacity:0!important;pointer-events:none!important;transition:opacity 220ms}'
  + '.fb-legal .ck-link{appearance:none;background:none;border:0;padding:0;margin:0;cursor:pointer;font:inherit;color:inherit;letter-spacing:inherit;text-decoration:inherit}';

  /* a shortbread round, drawn in the brass line: the one bit of play */
  var MARK = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true">'
    + '<path d="M24 4.5c2 0 3.2 1.6 5 2.1 1.9.5 3.8-.3 5.4.7 1.6 1 1.8 3 3.1 4.3 1.3 1.3 3.3 1.5 4.3 3.1 1 1.6.2 3.5.7 5.4.5 1.8 2.1 3 2.1 5s-1.6 3.2-2.1 5c-.5 1.9.3 3.8-.7 5.4-1 1.6-3 1.8-4.3 3.1-1.3 1.3-1.5 3.3-3.1 4.3-1.6 1-3.5.2-5.4.7-1.8.5-3 2.1-5 2.1s-3.2-1.6-5-2.1c-1.9-.5-3.8.3-5.4-.7-1.6-1-1.8-3-3.1-4.3-1.3-1.3-3.3-1.5-4.3-3.1-1-1.6-.2-3.5-.7-5.4C6.1 27.2 4.5 26 4.5 24s1.6-3.2 2.1-5c.5-1.9-.3-3.8.7-5.4 1-1.6 3-1.8 4.3-3.1 1.3-1.3 1.5-3.3 3.1-4.3 1.6-1 3.5-.2 5.4-.7 1.8-.5 3-2.1 5-2.1z"/>'
    + '<circle cx="24" cy="24" r="12.5" stroke-dasharray="1.2 3.2"/>'
    + '<g class="ck-crumb" fill="currentColor" stroke="none"><circle cx="19" cy="20" r="1.25"/><circle cx="24" cy="18" r="1.25"/><circle cx="29" cy="20" r="1.25"/>'
    + '<circle cx="21.5" cy="25" r="1.25"/><circle cx="26.5" cy="25" r="1.25"/><circle cx="24" cy="30" r="1.25"/></g></svg>';
  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<circle cx="12" cy="12" r="10.25"/><path d="M7.5 12.4l3 3 6-6.6"/></svg>';

  var U = (W.CHROME && W.CHROME.urls) || {};
  var POLICY = U.privacyPolicy || '/policies/privacy-policy';

  /* ---------- the measure: one beacon a decision, never a person ---------- */
  var SID = Math.random().toString(36).slice(2, 10), T0 = Date.now(), sent = 0;
  function beacon(k, t) {
    try {
      if (!(W.ADM_ENQUIRY && W.ADM_ENQUIRY.enabled) || sent >= 6) return;
      if (!/(^|\.)artisandelimarket\.co\.uk$/.test(location.hostname)) return;
      var d = { k: k, p: String(location.pathname).slice(0, 120), sid: SID, ms: Date.now() - T0,
                dev: W.matchMedia && W.matchMedia('(max-width: 760px)').matches ? 'm' : 'd' };
      if (t) d.t = t;
      var body = JSON.stringify(d); sent++;
      if (navigator.sendBeacon) navigator.sendBeacon('https://deli-rates.feralclo.com/signal', new Blob([body], { type: 'text/plain' }));
    } catch (_) {}
  }

  /* ---------- Shopify's consent switch ---------- */
  function cp() { return W.Shopify && W.Shopify.customerPrivacy; }
  function whenReady(fn) {
    var tries = 0, asked = false;
    (function poll() {
      var api = cp();
      if (api && typeof api.setTrackingConsent === 'function') return fn(api);
      if (!asked && tries > 6 && W.Shopify && typeof W.Shopify.loadFeatures === 'function') {
        asked = true;
        try { W.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {}); } catch (_) {}
      }
      if (++tries > 50) return fn(null);          /* ~10 s: Shopify never gave us the switch */
      setTimeout(poll, 200);
    })();
  }
  function current(api) {
    var c = {};
    try { c = (api && api.currentVisitorConsent && api.currentVisitorConsent()) || {}; } catch (_) {}
    return { analytics: c.analytics === 'yes', marketing: c.marketing === 'yes', preferences: c.preferences === 'yes' };
  }
  /* ---------- the answer, also kept here (20 Oct 2026) ----------
     On an iPhone the card came back after "Essentials only" (the phone journeys, WebKit only). Why, MEASURED that
     day: Shopify keeps the answer server-side, but in Safari Shop's sign-in recognition sends the next page through
     shop.app and back (/accounts/sur, the page returns with ?_su_rec=), and that one page is rendered with no answer
     at all (currentVisitorConsent all ''), so this card asked again; the pages after it had the answer back. So the
     answer is also kept in this browser (a consent record is itself essential), and a page where Shopify has
     forgotten it is given it back quietly instead of asking. A year, as Shopify's own cookie. Shopify's answer,
     when it has one, always wins and refreshes this copy. */
  var KEPT = 'adm-ck', YEAR = 365 * 864e5;
  function keep(c) {
    try { localStorage.setItem(KEPT, JSON.stringify({ a: +!!c.analytics, m: +!!c.marketing, p: +!!c.preferences, t: Date.now() })); } catch (_) {}
  }
  function kept() {
    try {
      var k = JSON.parse(localStorage.getItem(KEPT) || 'null');
      if (!k || !(Date.now() - k.t < YEAR)) return null;
      return { analytics: !!k.a, marketing: !!k.m, preferences: !!k.p };
    } catch (_) { return null; }
  }
  function save(api, c, done) {
    try {
      api.setTrackingConsent({ analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences,
                               sale_of_data: !!c.marketing }, function () { done && done(); });
    } catch (_) { done && done(); }
  }

  /* ---------- the card ---------- */
  var card, api = null, shownAt = 0;
  function row(key, title, line, locked) {
    return '<li class="ck-row"><div><b>' + title + '</b><small>' + line + '</small></div>'
      + '<label class="ck-sw' + (locked ? ' is-locked' : '') + '"><input type="checkbox" role="switch" '
      + (locked ? 'checked disabled aria-label="' + title + ', always on"' : 'data-ck="' + key + '" aria-label="' + title + '"')
      + '><span></span></label></li>';
  }
  function build() {
    if (!doc.getElementById('ck-style')) {
      var st = doc.createElement('style'); st.id = 'ck-style'; st.textContent = CSS; doc.head.appendChild(st);
    }
    card = doc.createElement('section');
    card.className = 'ck';
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-modal', 'false');
    card.setAttribute('aria-labelledby', 'ck-title');
    card.setAttribute('aria-describedby', 'ck-body');
    card.innerHTML = ''
      + '<div class="ck-in">'
      +   '<div class="ck-top"><div class="ck-mark">' + MARK + '</div><div>'
      +     '<p class="ck-eye">A quick word</p>'
      +     '<h2 class="ck-title" id="ck-title">Cookies, <em>the useful kind.</em></h2>'
      +   '</div></div>'
      +   '<p class="ck-body" id="ck-body">A few keep your basket and delivery day in place. With your yes, the rest show us which hampers people love and which of our adverts are worth keeping. <a href="' + POLICY + '">How we use them</a></p>'
      +   '<div class="ck-more" aria-hidden="true"><div><ul class="ck-list">'
      +     row('', 'Essential', 'Your basket, the delivery day and a safe checkout. The site needs these.', true)
      +     row('analytics', 'Analytics', 'Which pages and hampers people use, so we can make the shop better.')
      +     row('marketing', 'Adverts', 'Lets Google and Meta tell us which of our adverts work, and show them to people who have visited.')
      +     row('preferences', 'Preferences', 'Remembers small choices between visits.')
      +   '</ul></div></div>'
      +   '<div class="ck-acts"><button type="button" class="ck-btn ck-yes" data-ck-act="accept">Accept all</button>'
      +     '<button type="button" class="ck-btn ck-no" data-ck-act="essentials">Essentials only</button></div>'
      +   '<div class="ck-foot"><button type="button" class="ck-choose" data-ck-act="choose" aria-expanded="false">Choose for myself</button>'
      +     '<span class="ck-note">Change it any time</span></div>'
      + '</div>'
      + '<div class="ck-done" role="status">' + TICK + '<span>Saved. You can change it any time at the foot of the page.</span></div>';
    doc.body.insertBefore(card, doc.body.firstChild);   /* first in the tab order, without taking focus */
    card.addEventListener('click', onClick);
  }
  function open(choosing) {
    if (!card) build();
    card.classList.remove('is-done', 'is-out');
    setChoosing(!!choosing);
    void card.offsetWidth;
    card.classList.add('is-in');
    html.classList.add('ck-up');
  }
  function setChoosing(on) {
    var more = card.querySelector('.ck-more'), yes = card.querySelector('[data-ck-act="accept"]'),
        no = card.querySelector('[data-ck-act="essentials"]'), ch = card.querySelector('.ck-choose');
    card.classList.toggle('is-open', on);
    more.setAttribute('aria-hidden', on ? 'false' : 'true');
    ch.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) {
      var c = current(api);
      [].forEach.call(card.querySelectorAll('[data-ck]'), function (i) { i.checked = !!c[i.getAttribute('data-ck')]; });
      no.textContent = 'Save my choices'; no.setAttribute('data-ck-act', 'save');
    } else {
      no.textContent = 'Essentials only'; no.setAttribute('data-ck-act', 'essentials');
    }
    [].forEach.call(card.querySelectorAll('.ck-more input:not([disabled])'), function (i) { i.tabIndex = on ? 0 : -1; });
    yes.textContent = 'Accept all';
  }
  function finish(c, kind, t) {
    beacon(kind, t);
    keep(c);
    if (!api) { close(); return; }
    save(api, c, function () {});
    card.classList.add('is-done');
    var sheet = card.querySelector('.ck-mark .ck-crumb');
    if (sheet) sheet.style.transform = 'rotate(30deg)';
    setTimeout(close, 1700);
  }
  function close() {
    if (!card) return;
    card.classList.add('is-out'); card.classList.remove('is-in');
    html.classList.remove('ck-up');
    setTimeout(function () { if (card && card.classList.contains('is-out')) { card.parentNode && card.parentNode.removeChild(card); card = null; } }, 450);
  }
  function onClick(e) {
    var b = e.target.closest('[data-ck-act]'); if (!b) return;
    var act = b.getAttribute('data-ck-act');
    if (act === 'accept') finish({ analytics: true, marketing: true, preferences: true }, 'cookie-accept');
    else if (act === 'essentials') finish({}, 'cookie-essentials');
    else if (act === 'choose') { setChoosing(!card.classList.contains('is-open')); if (card.classList.contains('is-open')) beacon('cookie-choose'); }
    else if (act === 'save') {
      var c = {};
      [].forEach.call(card.querySelectorAll('[data-ck]'), function (i) { c[i.getAttribute('data-ck')] = i.checked; });
      finish(c, 'cookie-save', 'a' + (+!!c.analytics) + 'm' + (+!!c.marketing) + 'p' + (+!!c.preferences));
    }
  }

  /* ---------- "Cookie settings" in the footer, on every page ---------- */
  function footerLink() {
    var legal = doc.querySelector('#site-footer .fb-legal, .foot .fb-legal');
    if (!legal || legal.querySelector('.ck-link')) return;
    var a = doc.createElement('button');
    a.type = 'button'; a.className = 'ck-link'; a.textContent = 'Cookie settings';
    a.addEventListener('click', function () { open(true); var f = card && card.querySelector('.ck-more input:not([disabled])'); f && f.focus(); });
    legal.appendChild(a);
  }

  /* ---------- go ---------- */
  html.classList.add('adm-consent');      /* hide Shopify's box at once, so it never flashes */
  function start() {
    try {
      var st = doc.createElement('style'); st.id = 'ck-style'; st.textContent = CSS; doc.head.appendChild(st);
      footerLink();
      whenReady(function (got) {
        api = got;
        if (!api) { html.classList.remove('adm-consent'); return; }   /* no switch to answer: leave Shopify to it */
        var ask = false;
        try { ask = typeof api.shouldShowBanner === 'function' && api.shouldShowBanner(); } catch (_) {}
        /* shouldShowBanner says whether this REGION is asked, not whether this
           visitor has answered: it stays true after a choice (MEASURED 16 Oct on
           the live shop). An answer is any of the three set to yes or no. */
        var had = {};
        try { had = (api.currentVisitorConsent && api.currentVisitorConsent()) || {}; } catch (_) {}
        if (had.analytics || had.marketing || had.preferences) {         /* Shopify has the answer: keep our copy in step */
          keep({ analytics: had.analytics === 'yes', marketing: had.marketing === 'yes', preferences: had.preferences === 'yes' });
          return;
        }
        var mine = kept();
        if (mine) { save(api, mine, function () {}); return; }   /* answered before, forgotten on this page */
        if (!ask) return;
        var wait = Math.max(0, 900 - (Date.now() - T0));
        setTimeout(function () {
          try { open(false); shownAt = Date.now(); beacon('cookie-shown'); }
          catch (err) { html.classList.remove('adm-consent'); }
        }, wait);
      });
    } catch (err) { html.classList.remove('adm-consent'); }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
})();
